import React, { useEffect } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";
import "aos/dist/aos.css";
import AOS from "aos";
import "react-accessible-accordion/dist/fancy-example.css";
import "./../../HomePage/Faq/Faq.css";
const MeaFaqMain = () => {
  useEffect(() => {
    AOS.init({
      duration: 600,
    });
  }, []);
  return (
    <div className="faqMainContainer">
      <Accordion className="faqMainContent" allowZeroExpanded>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>What is MEA Apostille?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="faqPanel">
            <p>
              MEA Apostille is an official sticker issued by the Ministry of
              External Affairs (MEA), Government of India. It authenticates your
              document for use in all Hague Convention Countries (like Germany,
              France, Italy, UAE*, Netherlands, etc.). It replaces Embassy
              Attestation for most countries.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Who needs MEA Apostille in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You need Apostille if you are applying for:
              <ul>
                <li> Study Visa</li>
                <li> Work / Employment Visa</li>
                <li> Family Visa / Dependent Visa</li>
                <li> Migration / PR</li>
                <li> Internship Abroad</li>
                <li> Business & Legal Use Abroad</li>
                <li> Medical Treatment Overseas</li>
              </ul>
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3> What documents are required for Apostille in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              You usually need:
              <ul>
                <li> Original certificate</li>
                <li> Passport copy</li>
                <li> Aadhar copy</li>
                <li> Photographs (for some cases)</li>
                <li> Authorization letter (if applying through an agency)</li>
              </ul>
              For commercial documents, company seal + ID proof is needed.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How long does the MEA Apostille process take?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Standard processing time:
              <ul>
                <li> Same Day / 24 Hours (depending on state HRD/Home Dept)</li>
                <li> 2–5 working days (for most educational/personal docs)</li>
                <li>7–12 working days (if state authentication is delayed)</li>
              </ul>
              Express services are available through authorized agencies.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Is State HRD/Home Department attestation required before MEA
                Apostille?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes, in most cases.
              <ul>
                <li>
                  {" "}
                  <b>Degrees/Diplomas</b> → need HRD/University/SDM attestation
                </li>
                <li>
                  <b>Birth/Marriage Certificates</b> → need Home Department or
                  SDM attestation
                </li>
                <li>
                  <b>Commercial Docs</b> → need Chamber of Commerce attestation
                </li>
              </ul>
              Agencies help customers choose the fastest route.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>How much does MEA Apostille cost in Bangalore?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Cost depends on:
              <ul>
                <li> Document type (Education/Personal/Commercial)</li>
                <li> Whether HRD/Home/SDM attestation is needed</li>
                <li> Same-day vs normal processing</li>
              </ul>
              Typical range: ₹1,500 to ₹6,500 per document (all inclusive).
              Commercial document charges differ.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Can I track my Apostille status?</h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. You can track via:
              <ul>
                <li> MEA Apostille Portal</li>
                <li> Updates from the attestation agency</li>
                <li> SMS updates (depending on the service provider)</li>
              </ul>
              A good agency will provide real-time tracking.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>Is MEA Apostille valid for all countries? </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              MEA Apostille is valid only for Hague Convention Countries, such
              as: Germany, France, Italy, Poland, Netherlands, Portugal, Spain,
              Greece, Japan, Australia, etc.
            </p>
            <p>
              Countries NOT in Hague Convention — like UAE, Qatar, Kuwait, Saudi
              Arabia — still need Embassy Attestation instead of Apostille.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
        <AccordionItem className="faqItem" data-aos="fade-right">
          <AccordionItemHeading className="faqHead">
            <AccordionItemButton className="faqBut">
              <h3>
                Can an Apostille agency in Bangalore help with the entire
                process?
              </h3>
            </AccordionItemButton>
          </AccordionItemHeading>
          <AccordionItemPanel className="faqPanel">
            <p>
              Yes. Agencies assist with:
              <ul>
                <li> Document pick-up & drop</li>
                <li> HRD / SDM / Home Department attestation</li>
                <li> MEA Apostille stamping</li>
                <li> Commercial document apostille</li>
                <li> Real-time tracking</li>
                <li> Quick turnaround for urgent cases</li>
              </ul>
              This saves time, avoids errors, and ensures smooth processing.
            </p>
          </AccordionItemPanel>
        </AccordionItem>
      </Accordion>
    </div>
  );
};

export default MeaFaqMain;
